export class BatteryCssClasses {
	static mdiBattery = "mdi-battery";
	static mdiBatteryAlert = "mdi-battery-alert";
	static mdiBatteryPrefix = "mdi-battery-";
	static mdiPluggedIn = "mdi-power-plug";
}